<button
  mat-button
  [matMenuTriggerFor]="menu"
  aria-label="content-language"
  class="language-selector-button"
>
  <div class="flex gap-2 items-center">
    <img [src]="selectedLang.img" class="h-6 rounded-full" alt="flag" />
    <p class="text-sm">{{ selectedLang.code | uppercase }}</p>
  </div>
</button>
<mat-menu #menu="matMenu" class="flex flex-col ms-4">
  @for (lang of languages; track $index) {
  <button class="px-1" mat-menu-item (click)="selectLanguage(lang)">
    <div
      class="flex items-center rtl:flex-row-reverse gap-1 px-2 py-2 text-sm hover:bg-light-blue rounded-lg transition-colors w-40"
    >
      <img [src]="lang.img" class="h-6 me-2 text-secondary" alt="flag" />
      <span>{{ lang.label }}</span>
    </div>
  </button>
  }
</mat-menu>
